import React, { useState, useEffect, useRef } from 'react';

type Option = { value: string; label: string };

type InlineSelectCellProps = {
  value?: string;
  options: Option[];
  onSave?: (newValue: string) => void;
  placeholderText?: string;
};

const InlineSelectCell: React.FC<InlineSelectCellProps> = ({
  value = '',
  options,
  onSave,
  placeholderText = '',
}) => {
  const [editing, setEditing] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);
  const [hovered, setHovered] = useState(false);
  const selectRef = useRef<HTMLSelectElement>(null);

  useEffect(() => {
    setSelectedValue(value ?? '');
  }, [value]);

  useEffect(() => {
    if (editing && selectRef.current) {
      selectRef.current.focus();
    }
  }, [editing]);

  const handleSave = () => {
    if (onSave) onSave(selectedValue);
    setEditing(false);
  };

  if (editing) {
    return (
      <select
        ref={selectRef}
        value={selectedValue}
        onChange={e => setSelectedValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={e => {
          if (e.key === 'Enter') handleSave();
          if (e.key === 'Escape') {
            setEditing(false);
            setSelectedValue(value ?? '');
          }
        }}
        style={{
          width: '100%',
          minWidth: 80,
          border: '1px solid #ccc',
          borderRadius: 4,
          padding: '2px 6px',
          fontSize: 14,
        }}
      >
        <option value="">{placeholderText || 'Selecciona una opción'}</option>
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    );
  }

  return (
    <span
      style={{
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'left',
        minWidth: 80,
        color: '#495057',
        width: '100%',
        textAlign: 'left',
      }}
      onClick={() => setEditing(true)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      title="Haz click para editar"
    >
      {value
        ? options.find(opt => opt.value === value)?.label || value
        : (
          <span style={{ fontSize: 13, color: '#adb5bd' }}>
            {placeholderText}
          </span>
        )
      }
      <button
        type="button"
        style={{
          background: hovered ? '#f4f6fa' : 'transparent',
          border: 'none',
          padding: 4,
          borderRadius: 4,
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          marginLeft: 2,
        }}
        onClick={e => {
          e.stopPropagation();
          setEditing(true);
        }}
        tabIndex={-1}
      >
        <i
          className="fas fa-pen"
          style={{
            fontSize: 13,
            color: hovered ? '#5e72e4' : '#adb5bd',
          }}
        />
      </button>
    </span>
  );
};

export default InlineSelectCell;